import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Navbar from '../components/Navbar/Main'
import Footer from '../components/Footer/Main'
import Home from '../components/Home/Main'
import AboutUs from '../components/AboutUs/Main'
import Service from '../components/Service/Main'
import ServiceDetails from '../components/Service/ServiceDetails/Main'
import Gallery from '../components/Pages/Gallery/Main'
import Pricing from '../components/Pages/Pricing/Main'
import Faq from '../components/Pages/Faq/Main'
import Contact from '../components/Contact/Main'
import PermanentMakeup from '../components/Service/ServiceDetails/PermanentMakeup'
import Nails from '../components/Service/ServiceDetails/Nails'
import Eyelashes from '../components/Service/ServiceDetails/Eyelashes'
import BabyLips from '../components/Service/ServiceDetails/BabyLips'
import Vega from '../components/Service/ServiceDetails/Vega'
import Depilation from '../components/Service/ServiceDetails/Depilation'
import Hairdresser from '../components/Service/ServiceDetails/Hairdresser'
import Giftcard from '../components/Pages/Giftcard/Main'
import Educations from '../components/Pages/Educations/Main'
import Offers from '../components/Pages/Offers/Main'
import AdvancedCourse from '../components/Pages/AdvancedCourse/Main'
import { allSlugsFor } from '../i18n/lang.mjs'
import { WIGS_ENABLED } from '../config/features.mjs'
import Blog from '../components/BlogMain/Blog/Main'
import Balayage from '../components/Pages/Hair/Balayage'
import HairColouring from '../components/Pages/Hair/HairColouring'
import HairTreatments from '../components/Pages/Hair/HairTreatments'
import MensHaircut from '../components/Pages/Hair/MensHaircut'
import HairExtensions from '../components/Pages/Hair/HairExtensions'
import Wigs from '../components/Pages/Hair/Wigs'
import Jobs from '../components/Pages/Jobs/Main'
import Seo from '../seo/Seo'
import OfferPopup from '../components/ui/OfferPopup'
import { initGA, logPageView } from "../analytics";

const Routing = () => {

  const location = useLocation();
  const path = location.pathname

  // Initialize synchronously from the URL so the first render matches the
  // pre-rendered (react-snap) markup - otherwise hydration mismatches
  // (React error #423) because the Navbar would be absent on first paint.
  const [homepage, sethomepage] = useState(location.pathname !== "/home-three")
  useEffect(() => {
    sethomepage(location.pathname !== "/home-three")
  }, [location])

  // Soft language redirect for RETURNING visitors only: if a real user lands
  // on the prefix-less root and previously chose en/de, send them to their
  // language. Never runs during pre-render (ReactSnap UA) and never overrides
  // an explicit /en or /de URL, so Googlebot always gets the requested version.
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (navigator.userAgent === 'ReactSnap') return
    if (window.location.pathname !== '/') return
    const pref = localStorage.getItem('vb_lang')
    if (pref === 'en' || pref === 'de') {
      window.location.replace(`/${pref}/`)
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [path])

 // ---------- GOOGLE ANALYTICS ----------
  useEffect(() => {
    initGA(); 
  }, []);

  useEffect(() => {
    logPageView(location.pathname + location.search); // šalje pageview svaki put kad se ruta promeni
  }, [location]);

  return (
    <>
      <Seo />
      {homepage && <Navbar />}
      {/* flex column + min-height ensures Footer always sits at the
          bottom of the viewport even on short pages (sticky footer) */}
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/service" element={<Service />} />
            <Route path="/makeup" element={<ServiceDetails />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/permanent-makeup" element={<PermanentMakeup/>}/>
            <Route path="/nails" element={<Nails/>}/>
            <Route path="/eyelashes" element={<Eyelashes/>}/>
            <Route path="/baby-lips" element={<BabyLips/>}/>
            <Route path="/vega" element={<Vega/>}/>
            <Route path="/depilation" element={<Depilation/>}/>
            <Route path="/hairdresser" element={<Hairdresser/>}/>
            <Route path="/giftcard" element={<Giftcard/>}/>
            <Route path="/educations" element={<Educations/>}/>
            {/* /ponude - the running promotions. Same per-language slug
                treatment as the advanced course: /offers, /angebote. */}
            {allSlugsFor('/ponude').map((slug) => (
              <Route key={slug} path={slug} element={<Offers/>}/>
            ))}
            {/* The advanced course has a different slug per language. The
                router basename already selects the language, but registering
                every slug keeps a cross-language URL working instead of
                falling through to a blank page. */}
            {allSlugsFor('/napredni-kurs-sminkanja').map((slug) => (
              <Route key={slug} path={slug} element={<AdvancedCourse/>}/>
            ))}
            <Route path="/blog" element={<Blog/>}/>
            <Route path="/jobs" element={<Jobs />} />
            {/* Same URL as when this was a blog post - the position it had
                earned is worth more than a tidier slug. */}
            <Route path="/balayage" element={<Balayage />} />

            {/* Hair sub-pages, each on its own slug per language. */}
            {[
              ['/farbanje-kose', <HairColouring />],
              ['/tretmani-kose', <HairTreatments />],
              ['/musko-sisanje', <MensHaircut />],
              ['/ekstenzije-za-kosu', <HairExtensions />],
              // Wigs are not in stock yet - see src/config/features.mjs.
              ...(WIGS_ENABLED ? [['/perike', <Wigs />]] : []),
            ].map(([route, element]) => allSlugsFor(route).map((slug) => (
              <Route key={slug} path={slug} element={element} />
            )))}
          </Routes>
        </main>
        <Footer />
      </div>
      {/* Bottom bar / corner card, never a full-screen interstitial - see the
          note in OfferPopup. It hides itself on the pages that already sell
          the offer. */}
      <OfferPopup />
    </>
  )
}

export default Routing